import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Typography, CircularProgress, Button } from '@material-ui/core';

import Spec from '../../../../models/Spec';
import { SpecPaper } from '../../../../components/Paper';
import AdminLayout from '../../../../layouts/AdminLayout';
import utils from '../../../../libs/utils';

const SpecView = (props: RouteComponentProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [existingSpecs, setExistingSpecs] = useState<Spec[]>([]);
  const [spec, setSpec] = useState<Spec>(
    new Spec({
      id: 'UNTITLED-QUESTION',
      data: [
        {
          arguments: [],
          mainInvoker: 'main()',
          output: '',
        },
      ],
    }),
  );

  const loadExistingSpecs = async () => {
    try {
      setIsLoading(true);
      setErrorMessage('');
      setExistingSpecs(await Spec.fetchList());
    } catch (e) {
      setErrorMessage(utils.getRequestErrorMessage(e));
    } finally {
      setIsLoading(false);
    }
  };

  const handleOnBeforeSpecSave = (spec: Spec) => {
    for (let existingSpec of existingSpecs) {
      if (existingSpec.id === spec.id) {
        throw new Error(`"${spec.id}" already exists.`);
      }
    }
  };

  const handleOnSpecSaved = (spec: Spec) => {
    setSpec(spec);
    props.history.push('/admin/specs');
  };

  useEffect(() => {
    setTimeout(loadExistingSpecs);
  }, []);

  return (
    <AdminLayout>
      <div className="py-3">
        <Typography variant="h5">Create New Spec</Typography>

        {(() => {
          if (isLoading)
            return (
              <div className="text-center p-5">
                <CircularProgress />
              </div>
            );

          if (errorMessage)
            return (
              <div className="text-center p-5">
                <Typography variant="h6">Something went wrong</Typography>
                <Typography>{errorMessage}</Typography>
                <Button
                  type="button"
                  color="primary"
                  onClick={loadExistingSpecs}
                >
                  Try Again
                </Button>
              </div>
            );

          return (
            <SpecPaper
              spec={spec}
              onBeforeSpecSave={handleOnBeforeSpecSave}
              onSpecSaved={handleOnSpecSaved}
              hideDeleteButton={true}
            />
          );
        })()}
      </div>
    </AdminLayout>
  );
};

export default SpecView;
